'use client';
import React from 'react';

import { MaterialsTableContext } from './MaterialsTableContext';
import { getFiltersFromTableData, filterTableData } from './utils';

const MaterialsTableContextProvider = ({ children, materialsTableData }) => {
  const [selectedFilters, setSelectedFilters] = React.useState([]);
  const [activeColumn, setActiveColumn] = React.useState(false);
  const [expandedRows, setExpandedRows] = React.useState({});

  // get all filters from fetched data
  const allFilters = React.useMemo(() => {
    const filters = getFiltersFromTableData(materialsTableData);

    return filters;
  }, [materialsTableData]);

  // filter fetched data based on selected filters
  const filteredTableData = React.useMemo(() => {
    if (selectedFilters.length === 0) return materialsTableData;
    return filterTableData(materialsTableData, selectedFilters);
  }, [materialsTableData, selectedFilters]);

  // handle active column - cross-cell hover effect
  const clearActiveColumn = React.useCallback(() => setActiveColumn(false), []);
  const handleActiveColumn = React.useCallback(
    index => {
      if (index === 0) return clearActiveColumn();
      if (index !== activeColumn) return setActiveColumn(index); // throttleActiveCol
    },
    [activeColumn, clearActiveColumn, setActiveColumn]
  );

  const handleRowExpansion = React.useCallback(rowId => {
    setExpandedRows(prevExpandedRows => ({
      ...prevExpandedRows,
      [rowId]: !prevExpandedRows[rowId],
    }));
  }, []);

  return (
    <MaterialsTableContext.Provider
      value={{
        selectedFilters,
        setSelectedFilters,
        allFilters,
        filteredTableData,
        activeColumn,
        handleActiveColumn,
        clearActiveColumn,
        handleRowExpansion,
        expandedRows,
      }}
    >
      {children}
    </MaterialsTableContext.Provider>
  );
};

export { MaterialsTableContext, MaterialsTableContextProvider };
